import { each, find, map } from '@dt/fe-utils/dist/lodash'
import { makeAutoObservable, autorun, runInAction, action } from 'mobx'
import { memberMobx } from '@mobxStore'
import { storeMobx } from 'restaurant'
import { PayApi } from 'api'

class BankCard {
  constructor () {
    makeAutoObservable(this, {
      init: action
    })
  }
  storeId?: number
  memberId?: number
  memberType?: 'member' | 'user' | 'virtual'
  memberBankCards: IMutBankCardInfo[] = []
  maskedPanList: string[] = []

  async init (storeId: number, memberId: number, memberType: 'member' | 'user' | 'virtual', force?: boolean) {
    if (storeId === this.storeId && memberId === this.memberId && this.memberType === memberType && !force) {
      return
    }
    this.storeId = storeId
    this.memberId = memberId
    this.memberType = memberType

    // console.log('会员银行卡初始化', memberId)

    if (!memberId || memberType !== 'member') {
      this.memberBankCards = []
      return
    }

    const lastUsedBankCardNo = localStorage.getItem('last_used_bank_card_no')

    const { result } = await PayApi.listCreditCard({ storeId, memberId, useType: 'dc' }) as any
    const cards = result as {
      creditCardNo: string;
      creditCardNumber: string;
      type: TBankCartType;
    }[]

    runInAction(() => {
      this.memberBankCards = map(cards, ({ creditCardNo, creditCardNumber, type: creditCardType }) => {
        return {
          tokenType: 'multi',
          creditCardType,
          creditCardNo,
          creditCardNumber,
          lastUsed: creditCardNo === lastUsedBankCardNo
        }
      })
    })
  }

  async loadMaskedPan () {
    const { memberId, type } = memberMobx.memberInfo
    if (!memberId || type !== 'member') {
      this.maskedPanList = []
    }
    const { result, error } = await PayApi.ListCreditCardForMemberManagement(memberId) as any
    if (error) {
      throw error
    }
    runInAction(() => {
      this.maskedPanList = result.creditCardMaskedPanList
    })
  }

  async removeMaskedPan (maskedPan: string) {
    const { storeId } = storeMobx.info
    const { memberId, type } = memberMobx.memberInfo
    const { error } = await PayApi.deleteCreditCardForMemberManagement(memberId, maskedPan) as any
    if (error) {
      throw error
    }
    this.loadMaskedPan()
    this.init(storeId, memberId, type, true)
  }

  async authorize (channelType: TPayChannelType, token: string, details?: Record<string, string>): Promise<IMutBankCardInfo> {
    const { result, error } = await PayApi.authCreditCard({
      ...details,
      useType: 'dc',
      storeId: this.storeId,
      authCode: token,
      channelType,
      memberId: this.memberId,
    }) as any

    if (error) {
      throw error
    }

    const card = this.memberBankCards.find(x => x.creditCardNo === result.creditCardNo)

    if (!card) {
      const newCard: IMutBankCardInfo = {
        tokenType: 'multi',
        creditCardType: result.product,
        creditCardNo: result.creditCardNo,
        creditCardNumber: result.creditCardNumber,
      }
      if (this.memberType === 'member') {
        runInAction(() => {
          if (this.memberId !== 0) { this.memberBankCards.push(newCard) }
        })
      }
      return newCard
    } else {
      runInAction(() => {
        Object.assign(card, result)
      })
      return card
    }
  }

  setLastUsed (card: IMutBankCardInfo) {
    each(this.memberBankCards, x => {
      x.lastUsed = false
    })
    card.lastUsed = true
    const item = find(this.memberBankCards, x => x.creditCardNo === card.creditCardNo)
    if (item) {
      item.lastUsed = true
    }
    localStorage.setItem('last_used_bank_card_no', card.creditCardNo)
  }
}

const bankCardMobx = new BankCard()

autorun(async () => {
  const { storeId = 0 } = storeMobx.info
  const { memberId, type } = memberMobx.memberInfo
  bankCardMobx.init(storeId, memberId, type)
})

export default bankCardMobx
